<template>
	<div class="bg-white px-3 index" style="margin:0 26px;margin-bottom: 0!important;">
		<div class="add_tits" ref="titles">
			<el-form class="form-inlines u-f u-jsb" :inline="true">
				<div>
					<el-form-item label="状态">
						<el-select v-model="status" placeholder="请选择" size="small">
							<el-option label="全部" :value="0"></el-option>
							<el-option label="开启" :value="1"></el-option>
							<el-option label="关闭" :value="2"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="类型">
						<el-select v-model="type" placeholder="请选择" size="small">
							<el-option label="邀请主页图" :value="2"></el-option>
							<el-option label="邀请二维码图" :value="1"></el-option>
						</el-select>
					</el-form-item>
					<!-- <el-form-item label="时间">
						<el-date-picker v-model="times" size="small" type="daterange" value-format="yyyy-MM-dd"
							range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
						</el-date-picker>
					</el-form-item> -->
					<el-form-item>
						<el-button type="primary" icon="el-icon-search" size="small" @click="begin">搜索</el-button>
					</el-form-item>
				</div>
				<div>
					<el-form-item>
						<el-button type="primary" icon="el-icon-circle-plus-outline" size="small" @click="handleAdd">新增
						</el-button>
					</el-form-item>
				</div>
			</el-form>
		</div>
		<div class="ibox-content">
			<el-table :data="tableData" border v-loading="loading" :height="height" class="tableLimit">
				<el-table-column prop="id" label="编号" width="80"></el-table-column>
				<el-table-column prop="content" label="图片">
					<template slot-scope="scope">
						<div class="u-f u-wrap">
							<div v-for="(item,index) in scope.row.background" :key="index">
								<el-image style="width: 80px; height: 80px" fit='cover' :src="item.url"
									:preview-src-list="[item.url]">
								</el-image>
							</div>
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="create_time" label="添加时间" show-overflow-tooltip></el-table-column>
				<el-table-column prop="status" label="状态" show-overflow-tooltip>
					<template slot-scope="scope">
						<span>{{({1:'开启',2:'关闭'})[scope.row.status]}}</span>
					</template>
				</el-table-column>
				<el-table-column label="操作" width="350" align="center">
					<template slot-scope="scope">
						<el-button size="mini" type="info" v-if="scope.row.status!=1" @click="handle_top(scope.row,1)">
							开启
						</el-button>
						<el-button size="mini" type="primary" v-else plain @click="handle_top(scope.row,2)">关闭
						</el-button>
						<el-button size="mini" type="primary" icon="el-icon-edit-outline"
							@click="handleEdit(scope.row,scope.$index)"></el-button>
						<el-button size="mini" type="danger" icon="el-icon-delete"
							@click="handleDelet(scope.row,scope.$index)"></el-button>
					</template>
				</el-table-column>
			</el-table>
			<!-- <div class="u-f u-ac u-jsb ft_mr">
				<div></div>
				<div>
					<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
						:current-page="currentPage" :page-sizes="[15, 30, 50, 100]" :page-size="pagesize"
						layout="total, sizes, prev, pager, next, jumper" :total="count">
					</el-pagination>
				</div>
			</div> -->
		</div>
		<el-dialog title="设置" :visible.sync="dialogVisible" center top="120px" width="40%" class="dialogs">
			<el-divider></el-divider>
			<div class="dialog-ibox-content">
				<el-form :model="ruleForm" :rules="rule" ref="ruleForm" label-width="150px"
					class="demo-ruleForm forms-lines">
					<el-form-item label="类型" required>
						<el-select v-model="ruleForm.type" placeholder="请选择" size="small">
							<el-option label="邀请主页图" :value="2"></el-option>
							<el-option label="邀请二维码图" :value="1"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="图片" required>
						<el-upload class="avatar-uploader" action="/admin/image/upload" name="img" ref="upload"
							:headers="{ token:$store.state.user.token }"
							:data="{ image_class_id:'84' ,file_type:'1',dir:ruleForm.type==2?'hdBackground':'qrBackground'}"
							:file-list="ruleForm.lb_mapList" :on-success="uploadSuccess" :limit='1'
							:on-remove="uploadRmove" list-type="picture-card">
							<i class="el-icon-plus"></i>
						</el-upload>
					</el-form-item>
				</el-form>
			</div>
			<el-divider></el-divider>
			<span slot="footer" class="dialog-footer">
				<el-button @click="submit('ruleForm')" size="small" type="primary" :loading="subloading">提 交</el-button>
				<el-button @click="dialogVisible = false" size="small">取 消</el-button>
			</span>
		</el-dialog>

	</div>
</template>


<script>
	import Upload from "../../../components/uploadImg/upload.vue";
	import {
		mapState
	} from 'vuex'
	import tinymce from '@/components/common/tinymce.vue';
	export default {
		components: {
			tinymce,
			Upload
		},
		data() {
			return {
				lb_value: '',
				loading: false,
				tableData: [],
				count: 0,
				currentPage: 1,
				pagesize: 15,
				height: null,
				// 
				eid: '0',
				dialogVisible: false,
				subloading: false,
				ruleForm: {
					lb_mapList: [],
					type:1,
				},
				mapListed: [],
				fileListed: [],
				state_options: [],
				rule: {},
				// 
				urls: '',
				times: [],
				status: 0,
				type:1,
			};
		},
		computed: {
			...mapState({
				user: state => state.user.user,
			}),
		},
		created() {

		},
		mounted() {
			let that = this
			that.getHeight()
			that.begin()
		},
		methods: {
			getHeight() {
				let that = this
				var titles = that.$refs.titles.offsetHeight
				that.height = window.innerHeight - titles - 180 + 'px'
				window.onresize = () => {
					var titles = that.$refs.titles.offsetHeight
					that.height = window.innerHeight - titles - 180 + 'px'
				}
			},
			// 搜索
			begin() {
				let that = this
				that.currentPage = 1
				that.pagesize = 15
				that.search()
			},
			search() {
				let that = this
				that.tableData = []
				that.loading = true
				axios.post("/admin/wssadmin/background/index", {
						status: that.status,
						type: this.type,
					}, {
						token: true
					})
					.then(response => {
						that.loading = false
						that.tableData = response.data.data
					})
					.catch(error => {})
			},
			handleSizeChange(val) {
				let that = this
				that.pagesize = val;
				that.search()
			},
			handleCurrentChange(val) {
				let that = this
				that.currentPage = val;
				that.search()
			},
			handleAdd() {
				let that = this
				that.dialogVisible = true
				that.eid = '0'
				that.form_clear()
			},
			form_clear() {
				let that = this
				that.ruleForm.lb_mapList = []
				that.mapListed = []
			},

			submit(formName) {
				let that = this
				that.$refs[formName].validate((valid) => {
					if (valid) {
						if (that.mapListed.length < 1) return that.$message.error('请上传图片');
						that.subloading = true
						let urls;
						if (this.eid && this.eid != '0') {
							urls = "/admin/wssadmin/background/update"
						} else {
							urls = "/admin/wssadmin/background/save"
						}
						axios.post(urls, {
								id: that.eid,
								type: this.ruleForm.type,
								status: 1,
								background: that.mapListed,
								local_address: that.mapListed[0].local_url,

							}, {
								token: true
							})
							.then(response => {
								that.subloading = false
								if (response.data.code == '200') {
									that.dialogVisible = false
									that.search()
								} else {
									that.$message.error(response.data.msg);
								}
							})
							.catch(error => {
								that.subloading = true
							})
					} else {
						this.$alert("信息遗漏未填")
						return false;
					}
				});
			},
			// 编辑
			handleEdit(row, index) {
				let that = this
				let data = JSON.parse(
					JSON.stringify(row)
				)
				that.form_clear()
				that.dialogVisible = true
				that.eid = row.id
				that.ruleForm.lb_mapList = data.background
				that.ruleForm.type = data.type-0
				that.mapListed = data.background
			},
			// 删除
			handleDelet(row, index) {
				let that = this
				this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					axios
						.post("/admin/wssadmin/background/del", {
							id: row.id,
						}, {
							token: true
						})
						.then(response => {
							if (response.data.code == '200') {
								this.$message({
									type: 'success',
									message: '删除成功!'
								});
								that.search()
							} else {
								that.$message.error(response.data.msg);
							}
						})
						.catch(error => {})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
			gettimes() {
				let nowDate = new Date();
				let year = nowDate.getFullYear();
				let month = nowDate.getMonth() + 1;
				let day = nowDate.getDate();
				let hour = nowDate.getHours(); //获取系统时，
				let min = nowDate.getMinutes(); //分
				let sec = nowDate.getSeconds(); //秒
				month = month > 9 ? month : '0' + month
				day = day > 9 ? day : '0' + day
				hour = hour > 9 ? hour : '0' + hour
				min = min > 9 ? min : '0' + min
				sec = sec > 9 ? sec : '0' + sec
				return `${year}-${month}-${day} ${hour}:${min}`;
			},
			// 上传封面
			uploadSuccess(response, file, fileList) {
				let that = this
				if (response.code == "201") {
					that.$nextTick(() => {
						let mainImg = that.$refs.upload;
						if (mainImg) {
							mainImg.uploadFiles.forEach((element, index) => {
								if (file.uid == element.uid) {
									mainImg.uploadFiles.splice(index, 1)
								}
							});
						}
					})
					that.$alert(response.msg)
					return;
				}
				that.mapListed = []
				that.mapListed.push(response.data)
			},
			uploadRmove(file, fileList) {
				var index = this.mapListed.findIndex(item => item.id == file.id)
				this.mapListed.splice(index, 1)
			},
			handle_top(row, val) {
				axios
					.post("/admin/wssadmin/background/updateStatus", {
						id: row.id,
						status: val
					}, {
						token: true
					})
					.then(response => {
						if (response.data.code == '200') {
							this.$message({
								type: 'success',
								message: '操作成功!'
							});
							this.search()
						} else {
							this.$message.error(response.data.message);
						}
					})
					.catch(error => {})
			},

		},
		watch: {

		}

	};
</script>


<style>
	.index {
		border-radius: 6px;
		padding-bottom: 10px;
	}

	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 178px;
		height: 178px;
		line-height: 178px;
		text-align: center;
	}

	.avatar {
		width: 178px;
		height: 178px;
		display: block;
	}
</style>